/**
 * KAN-735: расходы организации (только владелец).
 *
 *   GET   /api/v1/expenses/?month=YYYY-MM  - статьи, итог, баланс OpenRouter, токены по дням, списания
 *   PATCH /api/v1/expenses/rate/           - курс доллара в рублях
 */
import apiClient from './client';
import type { ExpensesReport, UsdRubRate } from '@/types/expenses';

const BASE = '/api/v1/expenses/';

export const expensesApi = {
  get: async (month: string): Promise<ExpensesReport> =>
    (await apiClient.get<ExpensesReport>(BASE, { params: { month } })).data,
  updateRate: async (usdRubRate: number): Promise<UsdRubRate> =>
    (await apiClient.patch<UsdRubRate>(`${BASE}rate/`, { usd_rub_rate: usdRubRate })).data,
};
